export default () => {
    window.axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.response.status && error.response.status && error.response.status == 401) {
            location.reload()
        }
        return Promise.reject(error);
    });
    return window.axios
}



// WEBPACK FOOTER //
// ./resources/js/services/Api.js